import _ from 'lodash';

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import DropdownField from 'components/DropdownField';
import Loading from 'components/Loading/Loading';
import { compactDateTime } from '../../../../utils/timeUtils';

import { fetchAccountsWithIssues } from '../../../../actions/Admin/accountActions';
import { searchIssues, fetchResourceStatusOptions } from '../../../../actions/Admin/issueActions';
import { fetchTeachers } from '../../../../actions/teacherActions';

import './style.css';

class SearchIssues extends Component {
  constructor() {
    super();
    this._teachersHash = {};
  }

  componentWillMount() {
    this.props.searchIssues();
    this.props.fetchAccountsWithIssues();
    this.props.fetchTeachers();
    this.props.fetchResourceStatusOptions();
  }

  showIssueDetails = (issue) => {
    browserHistory.push({ pathname: `/admin/issues/${issue.id}`, state: { issue } });
  }

  filterIssues = (values) => {
    this.props.searchIssues(values);
  }

  clearForm = () => {
    this.props.reset();
  }

  renderTeacherSelector() {
    const teachers = this.props.teachers || [];

    const opts = _.map(teachers, teacher => {
      this._teachersHash[teacher.id] = teacher;
      return {
        label: teacher.slug,
        value: teacher.id
      };
    });

    return (
      <Field
        name="teacherId"
        component={DropdownField}
        options={opts}
        disabled={_.isEmpty(teachers)}
        placeholder={_.isEmpty(teachers) ? 'Loading...' : 'Teacher'}
      />
    );
  }

  renderStudentSelector() {
    const accounts = this.props.accounts.accounts || [];
    const opts = _.map(accounts.data, account => {
      return {
        label: `${account.name} - ${account.email}`,
        value: account.id
      };
    });

    return (
      <Field
        name="reporterId"
        component={DropdownField}
        options={opts}
        disabled={_.isEmpty(accounts)}
        placeholder={_.isEmpty(accounts) ? 'Loading...' : 'Student'}
      />
    );
  }

  renderRefundStatusSelector() {
    const refundStatusOptions = this.props.refundStatusOptions.refundStatusOptions || [];
    const opts = _.map(refundStatusOptions.data, refundStatus => {
      return {
        label: `${refundStatus}`,
        value: refundStatus
      };
    });

    return (
      <Field
        name="refundStatus"
        component={DropdownField}
        options={opts}
        disabled={_.isEmpty(refundStatusOptions)}
        placeholder={_.isEmpty(refundStatusOptions) ? 'Loading...' : 'Refund Status'}
      />
    );
  }

  renderSearchForm() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit(this.filterIssues)}>
        <div className="d-flex justify-content-center filter-form">
          <div className="mr-1 teacher-selector">{this.renderTeacherSelector()}</div>
          <div className="ml-1 mr-1 student-selector">{this.renderStudentSelector()}</div>
          <div className="ml-1 mr-1 refund-status-selector">
            {this.renderRefundStatusSelector()}
          </div>
          <button className="btn btn-primary" type="submit" disabled={submitting}>
            Filter
          </button>
          <button type="button" className="btn btn-warning ml-1" onClick={this.clearForm}>
            <i className="fa fa-undo" />
          </button>
        </div>
      </form>
    );
  }

  render() {
    return (
      <div className="SearchIssues">
        <div className="col-auto">
          <div className="row">{this.renderSearchForm()}</div>

          <div className="row">
            <div className="card">
              {this.props.issues.status === 'LOADING' && <Loading />}
              {this.props.issues.status === 'SUCCESS' && (
                <table className="table table-striped table-sm table-hover borderless">
                  <thead>
                    <tr>
                      <th scope="col">Issue Type</th>
                      <th scope="col">Reporter</th>
                      <th scope="col">Teacher</th>
                      <th scope="col">Refund Status</th>
                      <th scope="col">Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.issues.issues.data.data.map(issue => (
                      <tr
                        key={issue.id}
                        onClick={() => {
                          this.showIssueDetails(issue);
                        }}
                      >
                        <td>{issue.issueType.slug}</td>
                        <td>{issue.reporter.name}</td>
                        <td>
                          {this._teachersHash[issue.teacherId] ?
                            this._teachersHash[issue.teacherId].slug :
                            issue.teacherId}
                        </td>
                        <td>{issue.refundStatus}</td>
                        <td>{compactDateTime(issue.createdAt)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {this.props.issues.status === 'FAIL' && <div>Problem</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    issues: state.issueResults,
    accounts: state.accountResults,
    teachers: state.teachers,
    refundStatusOptions: state.refundStatusOptions
  };
}

export default compose(
  connect(mapStateToProps, {
    fetchAccountsWithIssues,
    searchIssues,
    fetchTeachers,
    fetchResourceStatusOptions
  }),
  reduxForm({
    form: 'searchIssuesForm',
    enableReinitialize: true
  })
)(SearchIssues);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/SearchIssues/index.js